/**
 * @fileoverview Placeholder image utility for project cards
 */

import PlaceholderBlueTop from '@legacy/assets/images/lumiar_patterns_blue_top.webp'
import PlaceholderBlueBottom from '@legacy/assets/images/lumiar_patterns_blue_bottom.webp'
import PlaceholderYellowTop from '@legacy/assets/images/lumiar_patterns_yellow_top.webp'
import PlaceholderYellowBottom from '@legacy/assets/images/lumiar_patterns_yellow_bottom.webp'

/**
 * Ensures the image path is absolute to work correctly on nested routes
 * esbuild generates relative paths (./image.png) which break on routes like /teacher/dashboard
 */
const toAbsolutePath = (path: string): string => {
  if (path.startsWith('data:')) {
    return path
  }
  if (path.startsWith('./')) {
    return path.slice(1) // './image.png' -> '/image.png'
  }
  if (path.startsWith('/')) {
    return path
  }
  return '/' + path
}

const PLACEHOLDER_IMAGES = [
  toAbsolutePath(PlaceholderBlueTop),
  toAbsolutePath(PlaceholderYellowBottom),
  toAbsolutePath(PlaceholderBlueBottom),
  toAbsolutePath(PlaceholderYellowTop),
] as const

/**
 * Generates a consistent hash from a UUID string
 * @param id - Project UUID
 * @returns Numeric hash value
 */
const hashUUID = (id: string): number => {
  return id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
}

/**
 * Gets a placeholder image for a project based on its ID
 * Uses deterministic selection so same project always gets same image
 * @param projectId - Project UUID
 * @returns Image source URL
 */
export const getPlaceholderImage = (projectId: string): string => {
  const hash = hashUUID(projectId)
  const index = hash % PLACEHOLDER_IMAGES.length
  return PLACEHOLDER_IMAGES[index]
}
